// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import createSessionWithLegacyToken from './createSessionWithLegacyToken'
import renewUserSession from './renewUserSession'

const authorizeNewSession = () => dispatch => (
  dispatch(loadingToggler(
    async () => {
      const jwt = localStorage.getItem('L_JWT')
      // expiration timestamp of token
      const ets = localStorage.getItem('L_ETS')

      if (jwt && ets > Date.now()) {
        // first check if there's a JWT token and it's not expired in local storage.
        // if there's a non expired jtw, then get a new one to start a new session
        await dispatch(renewUserSession())
      } else if (window.location.href.includes('token=')) {
        // if there's a legacy token in the url, try creating a new session based on that token
        await dispatch(createSessionWithLegacyToken())
      }

      // finally, remove any query from the url
      // NOTE - this assumes hash routing is being used
      // NOTE - this does not dispatch to react-router-redux because
      // as far as it's concerned, the page isn't changing.
      // NOTE - if we are loading on a nested route, window.location.search
      // will be empty and the query will be included in window.location.hash instead.
      const cleanedHash = window.location.hash.split('?')[0]
      history.replaceState(null, '', `/${cleanedHash}`)
    })
  )
)

export default authorizeNewSession
